import { UpdateV2Request } from '@weave/schema-gen-ts/dist/schemas/phone/callqueue-config/v1/callqueue_config_service.pb';
import { useQueryClient, useMutation } from 'react-query';
import CallQueueAPI from '@frontend/api-call-queue';
import { queryKeys } from '../../query-keys';
import { CallQueueCreatePayload, CallQueueState } from './types';

export const useCallQueueMutations = (phoneTenantId: string) => {
  const queryClient = useQueryClient();

  /**
   * Hold off on optimistic updates for now. These updates (setQueryData) cause an immediate rerender, which can cause the outer mutate options hooks to not fire.
   */
  const create = useMutation({
    mutationFn: (payload: CallQueueCreatePayload) => {
      return CallQueueAPI.Create(payload);
    },
    onSuccess: (data) => {
      queryClient.setQueryData([phoneTenantId, ...queryKeys.settings.readCallQueue(data.callQueueId)], data);
      queryClient.setQueryData([phoneTenantId, ...queryKeys.settings.listCallQueue()], (old: any) => {
        return [data, ...old];
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.listCallQueue()]);
    },
  });

  const update = useMutation({
    mutationFn: (payload: CallQueueState) => {
      return CallQueueAPI.Update(payload);
    },
    onSettled: (_data, _err, payload) => {
      queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.listCallQueue()]);
      queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.readCallQueue(payload.callQueueId)]);
    },
  });

  const updateV2 = useMutation({
    mutationFn: (payload: UpdateV2Request) => {
      return CallQueueAPI.UpdateV2(payload);
    },
    onSettled: (_data, _err, payload) => {
      queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.listCallQueue()]);
      queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.readCallQueue(payload.callQueueId)]);
    },
  });

  const remove = useMutation({
    mutationFn: (payload: { callQueueId: string }) => {
      return CallQueueAPI.Delete(payload);
    },
    onSettled: (_data, _err, payload) => {
      queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.listCallQueue()]);
      queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.readCallQueue(payload.callQueueId)]);
    },
  });

  return {
    create,
    update,
    updateV2,
    remove,
  };
};
